import React from 'react'
import { Col, Card, Button, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { ItemCard } from '../../../../models/Item'
import styles from './listingItem.module.css'

const ListingItem = ({
  imageSrc,
  itemTitle,
  itemDesc,
  itemButton,
  itemButtonUrl,
  itemActive,
  itemPrice
}: ItemCard) => {
  return (
    <>
      <Col xs={12} lg={4} className="pb-5 " data-testid="items">
        <Card className={styles.itemCard}>
          <div>
            <Card.Img
              variant="top"
              src={imageSrc || '/image.png'}
              alt="img-item"
              width="100%"
              height="250px"
              className="img-items"
              data-testid="item-image"
            />
            {itemActive ? (
              <Button variant="info" className={styles.listingActive}>
                ACTIVE
              </Button>
            ) : (
              <Button variant="danger" className={styles.listingDisabled}>
                DISABLED
              </Button>
            )}
          </div>
          <Card.Body className="d-flex flex-column ">
            <Row>
              <Col>
                <Card.Title>
                  <h3>
                    <b>
                      {itemTitle.substring(0, 20)}{' '}
                      {itemTitle.length > 20 ? <span>...</span> : null}
                    </b>
                  </h3>
                </Card.Title>
              </Col>
              <Col className="text-right">
                <Card.Title>
                  <h3>
                    <b data-testid="item-price">S$ {itemPrice} </b>
                  </h3>
                </Card.Title>
              </Col>
            </Row>

            <Card.Text className={styles.listingItemDescription}>
              {itemDesc.substring(0, 100)}
              {itemDesc.length > 100 ? <span>...</span> : null}
            </Card.Text>

            <Link to={itemButtonUrl!} className="mt-auto">
              <button
                className="btn btn-primary px-4 py-2 "
                data-testid="item-button"
              >
                {itemButton}
              </button>
            </Link>
          </Card.Body>
        </Card>
      </Col>
    </>
  )
}

export default ListingItem
